<template>
  <v-stepper-header class="wizard-header">
    <v-text-field
      class="wizard-alert-name application-heading"
      label="Name Your Alert"
      v-model="alert.name"
      solo
      flat
      outlined
    ></v-text-field>
    <v-stepper-step
      class="wizard-step-indicator"
      :step="wizardSteps.StartStep.id"
      :complete="true"
      @click="stepChanged(true, wizardSteps.AoiStep)"
    >
      Start
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step
      class="wizard-step-indicator"
      :step="wizardSteps.AoiStep.id"
      :complete="wizardSteps.AoiStep.isValid"
      @click="stepChanged(true, wizardSteps.AoiStep)"
    >
      Location
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step
      class="wizard-step-indicator"
      :step="wizardSteps.TripWiresStep.id"
      :complete="wizardSteps.TripWiresStep.isValid"
      :rules="[
        () => {
          return !(
            !wizardSteps.TripWiresStep.isValid &&
            wizardSteps.FrequencyStep.isValid
          );
        },
      ]"
      @click="
        stepChanged(wizardSteps.AoiStep.isValid, wizardSteps.TripWiresStep)
      "
    >
      Tripwires
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step
      class="wizard-step-indicator"
      :step="wizardSteps.FrequencyStep.id"
      :complete="wizardSteps.FrequencyStep.isValid"
      :rules="[
        () => {
          return !(
            !wizardSteps.FrequencyStep.isValid && wizardSteps.ShareStep.isValid
          );
        },
      ]"
      @click="
        stepChanged(
          wizardSteps.TripWiresStep.isValid,
          wizardSteps.FrequencyStep
        )
      "
    >
      Frequency
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step
      class="wizard-step-indicator"
      :step="wizardSteps.ShareStep.id"
      :complete="wizardSteps.ShareStep.isValid"
      @click="
        stepChanged(wizardSteps.FrequencyStep.isValid, wizardSteps.ShareStep)
      "
    >
      Share
    </v-stepper-step>
    <v-divider></v-divider>
    <v-stepper-step
      class="wizard-step-indicator"
      :step="wizardSteps.SummaryStep.id"
      @click="
        stepChanged(wizardSteps.ShareStep.isValid, wizardSteps.SummaryStep)
      "
    >
      Finish
    </v-stepper-step>
  </v-stepper-header>
</template>

<script>
const EMITTED_ACTIONS = {
  STEP_CHANGED: "step-changed",
};

export default {
  name: "AlertWizardHeader",
  props: {
    alert: {
      type: Object,
      required: true,
    },
    wizardSteps: {
      type: Object,
      required: true,
    },
  },
  methods: {
    stepChanged(reqsMet, step) {
      if (reqsMet) {
        this.$emit(EMITTED_ACTIONS.STEP_CHANGED, { step });
      }
    },
  },
};
</script>

<style lang="scss">
.wizard-header {
  border: none !important;
  box-shadow: none;
}
.wizard-alert-name >>> .v-text-field__slot > input {
  margin: 0;
  color: black;
  font-size: 19px;
  height: 40px;
}

.wizard-alert-name >>> .v-text-field__slot > label {
  color: #b5b5b5;
  font-size: 19px;
}

.wizard-alert-name {
  margin-top: 20px !important;
}

.wizard-header >>> .v-stepper__step__step {
  height: 10px;
  min-width: 10px;
  width: 10px;
  font-size: 0;
  margin: 0 0 0 0;
}

.wizard-header >>> .v-stepper__step--error .v-stepper__step__step {
  background-color: red !important;
  border-color: red !important;
  cursor: pointer;
}

.wizard-header >>> .v-stepper__step__step.primary {
  background-color: $primary-color !important;
  border-color: $primary-color !important;
  cursor: pointer;
}

.wizard-header >>> .v-stepper__step__step .v-icon {
  display: none;
}

.wizard-header >>> .v-stepper__label {
  cursor: pointer;
}

.wizard-header >>> .v-divider {
  margin: 29px -67px 0;
}

.wizard-step-indicator {
  padding: 24px 0px;
  max-width: 145px;
}
</style>
